import React from 'react'
import styled from '@emotion/styled'

import { IconButton, Menu, MenuItem } from '@mui/material'
import { MoreVert as MoreVertIcon } from '@mui/icons-material'

import { CopyCardToDashMenuItem } from './CopyCardToDashMenuItem'
import { DeleteCardMenuItem } from './DeleteCardMenuItem'
import { DuplicateCardMenuItem } from './DuplicateCardMenuItem'

import { CardViewMode } from '@edge/spark/io-dashboards'

interface CardIconMenuProps {
    handleConfig?: (widgetId: string) => void
    widgetId: string
    cardViewMode: CardViewMode
    readonly: boolean
}

const StyledMenuItem = styled(MenuItem)`
    min-width: 200px;
`

export const WidgetMenuIcon: React.FC<CardIconMenuProps> = ({
    handleConfig,
    widgetId,
    cardViewMode,
    readonly,
}: CardIconMenuProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const handleClose = (): void => {
        setAnchorEl(null)
    }

    const handleEdit = (): void => {
        setAnchorEl(null)
        handleConfig?.(widgetId)
    }

    const handleDuplicate = (): void => {
        setAnchorEl(null)
    }

    const handleCopy = (): void => {
        setAnchorEl(null)
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        setAnchorEl(event.currentTarget)
    }

    return readonly ? (
        <div />
    ) : (
        <div>
            <IconButton
                size="small"
                onClick={handleClick}
                disabled={cardViewMode === CardViewMode.CONFIGURATION || cardViewMode === CardViewMode.PANEL}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                keepMounted
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                <StyledMenuItem aria-disabled onClick={handleEdit}>
                    Edit
                </StyledMenuItem>
                <DuplicateCardMenuItem aria-disabled widgetId={widgetId} onClick={handleDuplicate}>
                    Duplicate
                </DuplicateCardMenuItem>
                <CopyCardToDashMenuItem aria-disabled widgetId={widgetId} onClick={handleCopy}>
                    Copy to...
                </CopyCardToDashMenuItem>
                <DeleteCardMenuItem aria-disabled widgetId={widgetId}>
                    Delete
                </DeleteCardMenuItem>
            </Menu>
        </div>
    )
}

export default WidgetMenuIcon
